module.exports = __webpack_public_path__ + "static/media/lolol_food_voucher.f16c5d4d.png";